// extracted by mini-css-extract-plugin
export default {"link":"hQdi2Y","root":"v7Wn2T","label":"LCzRMq"};